<template>
  <div>
    <div>
      <div class="columns is-vcentered">
        <div class="column">
          <div class="mb-md">
            <p class="has-text-weight-bold is-size-6">Expense Catgories</p>
            <p class="has-text-grey is-size-7">
              Customize the expense categories that can be used to classify expenses.
            </p>
          </div>
        </div>
        <div class="column is-narrow">
          <b-button native-type="submit" type="is-primary" :disabled="saving" @click="showEditCategoryModal = true">New Category</b-button>
        </div>
      </div>
      <div class="has-background-white has-shadow">
        <b-table
          :data="categories"
          :mobile-cards="false"
          :loading="loading"
          hoverable
          class="is-size-7">
          <b-table-column
            field="id"
            label="ID"
            width="64"
            cell-class="has-text-grey-light"
            v-slot="props">
            {{ props.row.id }}
          </b-table-column>
          <b-table-column
            field="name"
            label="Name"
            v-slot="props">
            <a href="#"
              class="has-text-weight-bold"
              @click.prevent="focus(props.row)">
              {{ props.row.name  }}
            </a>
          </b-table-column>
          <b-table-column
            field="id"
            label="Platform Links"
            width="96"
            centered
            v-slot="props">
            {{ props.row.identifiers_count }}
          </b-table-column>
          <template slot="empty">
            <div class="py-xxl has-text-grey has-text-centered">
              {{ (loading) ? "Loading data..." : 'No records found!' }}
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <!-- Modal: Create/Update -->
    <b-modal
      has-modal-card
      scroll="keep"
      :active.sync="showEditCategoryModal"
      :can-cancel="['x', 'esc']"
      @close="reset"
      ><EditExpenseCategoryModal :category="focusCategory" @category:saved="loadExpenseCategories(true)" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EditExpenseCategoryModal from '@/components/Models/ExpenseCategory/Modals/Edit'
export default {
  components: {
    EditExpenseCategoryModal
  },
  computed: {
    ...mapGetters(['api'])
  },
  data () {
    return {
      loading: true,
      categories: [],
      focusCategory: null,
      showEditCategoryModal: false,
      saving: false,
      errors: {}
    }
  },
  methods: {
    loadExpenseCategories (silent = false) {
      if (!silent) this.loading = true
      const endpoint = this.api.route + '/expense-categories'
      this.$http.get(endpoint).then(response => {
        this.categories = response.data.data
        this.loading = false
      })
    },
    focus (category) {
      this.focusCategory = category
      this.showEditCategoryModal = true
    },
    reset () {
      this.showEditCategoryModal = false
      this.focusCategory = null
    }
  },
  mounted () {
    this.loadExpenseCategories()
  }
}
</script>
